import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CONFIG_PORTA, type PortaChave } from '../portas';

export default function PortaRedirect({ porta }: { porta: PortaChave }) {
  const navigate = useNavigate();

  useEffect(() => {
    const cfg = CONFIG_PORTA[porta];
    if (cfg.para) {
      navigate(cfg.para, { replace: true });
      return;
    }
    const params = new URLSearchParams();
    params.set('porta', porta);
    if (cfg.categoria) params.set('categoria', cfg.categoria);
    if (cfg.forma) params.set('forma', cfg.forma);
    navigate(`/evento/novo?${params.toString()}`, { replace: true });
  }, [navigate, porta]);

  return null;
}